import { render } from "./FailureDialog.vue?vue&type=template&id=67dc1fba"
import script from "./FailureDialog.vue?vue&type=script&lang=js"
export * from "./FailureDialog.vue?vue&type=script&lang=js"

import "./FailureDialog.vue?vue&type=style&index=0&id=67dc1fba&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__